import React, { useEffect, useState } from 'react';
import { supabase } from '../utils/supabase';
import '../styles/EmailVerificationSuccess.css';

export default function EmailVerificationSuccess() {
  const [verifying, setVerifying] = useState(true);

  useEffect(() => {
    // Process the verification when component mounts
    const processVerification = async () => {
      try {
        // Check for hash params (Supabase returns tokens in URL hash after email verification)
        const hashParams = new URLSearchParams(window.location.hash.substring(1));
        const accessToken = hashParams.get('access_token');
        const type = hashParams.get('type');

        console.log('Processing email verification:', { accessToken: !!accessToken, type });

        if (accessToken && type === 'signup') {
          // Get the session to ensure verification is complete
          const { data: { session }, error } = await supabase.auth.getSession();
          
          if (error) {
            console.error('Error getting session:', error);
          } else if (session?.user?.email_confirmed_at) {
            console.log('✅ Email verification confirmed');
          }
        }
      } catch (error) {
        console.error('Error processing verification:', error);
      } finally {
        setVerifying(false);
      }
    };

    processVerification();
  }, []);

  return (
    <div className="verification-success-page">
      <div className="verification-success-container">
        {verifying ? (
          <>
            <div className="verification-icon verifying">⏳</div>
            <h1 className="verification-title">Verifying your email...</h1>
            <p className="verification-message">Please wait a moment.</p>
          </>
        ) : (
          <>
            <div className="verification-icon success">✓</div>
            <h1 className="verification-title">Thank you for Verifying!</h1>
            <p className="verification-message">
              Your email has been successfully verified.
            </p>
            <p className="verification-instruction">
              Please go back to the "In The Zone" website to login and complete your profile.
            </p>
            <div className="verification-note">
              You can close this tab now.
            </div>
          </>
        )}
      </div>
    </div>
  );
}

